import color from '@/uptk/core/packages/style/color';

export const unsupportedShadow = [[0, 12, 40, 5, color.unsupported]];

export const lightShadows = [
    'none',
    [[0, 2, 3, 0, 'color-mix(in srgb, black 10%, transparent)']],
    [[0, 2, 6, 0, 'color-mix(in srgb, black 10%, transparent)']],
    [[0, 4, 8, 0, 'color-mix(in srgb, black 10%, transparent)']],
    [[0, 8, 10, 0, 'color-mix(in srgb, black 10%, transparent)']],
    [[0, 8, 16, 0, 'color-mix(in srgb, black 20%, transparent)']],
    [[0, 12, 40, 5, 'color-mix(in srgb, black 30%, transparent)']],
];

export const darkShadows = [
    'none',
    [[0, 2, 3, 0, 'color-mix(in srgb, black 40%, transparent)']],
    [[0, 2, 6, 0, 'color-mix(in srgb, black 40%, transparent)']],
    [[0, 4, 8, 0, 'color-mix(in srgb, black 40%, transparent)']],
    [[0, 8, 10, 0, 'color-mix(in srgb, black 40%, transparent)']],
    [[0, 8, 16, 0, 'color-mix(in srgb, black 50%, transparent)']],
    [[0, 12, 40, 5, 'color-mix(in srgb, black 60%, transparent)']],
];

